import React from 'react';
import { TrialNotification } from '../components';
import EmailVerificationMessage from 'Shared/EmailVerificationMessage/EmailVerificationMessage';
import {observer} from "mobx-react-lite";
import {useStore} from "@/mstore";


function SaasHeaderMenuItems() {
    const {userStore} = useStore();
    const account = userStore.account;

    return (
        <div className="flex items-center">
            {!account.verifiedEmail && <EmailVerificationMessage email={account.email}/>}
            <TrialNotification className="mr-4 ml-4"/>
        </div>
    );
}

export default observer(SaasHeaderMenuItems);
